var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 557,
    height: 134,
    viewBox: "0 0 557 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1488 44.1982C40.8312 46.1775 12.5937 21.9317 0.264648 9.56139V133.265H556.265V70.1761C542.941 61.5168 514.624 44.1982 507.943 44.1982C499.591 44.1982 465.587 113.472 459.024 113.472C452.462 113.472 413.685 9.56139 402.947 0.902187C392.209 -7.75702 359.398 74.5054 349.853 83.1647C340.308 91.8239 325.99 26.8798 312.269 24.4057C298.548 21.9317 269.316 86.2572 253.209 99.246C237.102 112.235 218.011 49.1463 203.097 44.1982C188.183 39.2501 161.338 93.6794 153.582 93.6794C145.827 93.6794 115.999 9.56139 104.664 9.56139C93.329 9.56139 73.0458 41.7242 55.1488 44.1982Z",
    fill: "url(#paint0_linear_93_8106)",
    stroke: "#20DDAF",
    strokeWidth: 0.529326
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_8106",
    x1: 278.861,
    y1: -49.835,
    x2: 278.22,
    y2: 133.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20DDAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector 1.907f36c9f2dd44f3451b42ba3e6d481b.svg";
export { ForwardRef as ReactComponent };